import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import {
  ALL_STORES_BLANKSTREET_JOINED,
  SAME_STORES_BLANKSTREET_JOINED,
} from '@/constants'
import { PriceComplianceModel } from '@/types/clarityLens'

export const getPriceCompliance = async (
  branchName: string,
  startDate: string,
  endDate: string,
  itemName: string
): Promise<PriceComplianceModel> => {
  try {
    if (branchName === 'all') {
      branchName = ALL_STORES_BLANKSTREET_JOINED()
    } else if (branchName === 'same') {
      branchName = SAME_STORES_BLANKSTREET_JOINED
    }

    const response = await axios.get(
      `${BASE_URL}/spend-lens/item/sku-breakdown/price-compliance`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
          dcn: branchName,
          item_name: itemName,
          limit: 1000,
        },
      }
    )

    return response.data
  } catch (error) {
    throw error
  }
}
